import { TOUR_TRANSLATIONS } from "../translations"

export const getCatalogueDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="catalogue-details-filters"]',
            title: t.catalogueDetailsFilters.title,
            content: t.catalogueDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="catalogue-details-table"]',
            title: t.catalogueDetailsTable.title,
            content: t.catalogueDetailsTable.content,
        },
    ]
}
